<template>
  <div class="content">
    <el-button type="primary" class="btn-add" @click="comedit('row','new')" style="margin-bottom:28px">新增部门</el-button>

    <el-table
      :data="tableData"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <!--      <el-table-column-->
      <!--        label="ID"-->
      <!--        prop="id"-->
      <!--        align="center"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <el-table-column label="部门名称" prop="department_name" align="center">
      </el-table-column>
      <el-table-column label="部门负责人" prop="person" align="center">
      </el-table-column>
      <el-table-column label="当前月份在岗人数" prop="person_count" align="center">
      </el-table-column>
      <el-table-column label="当前月份固定成本(万元)" prop="cost" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <span class="caozuo" @click="jumpXQ(scope.row)" style="color:#347ae2;cursor: pointer;">部门详情</span>
          <span class="caozuo" @click="comedit(scope.$index, scope.row)"
                style="color:#347ae2;cursor: pointer;">修改部门</span>
          <span class="caozuo" @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除部门</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange">
    </Pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      class="diago"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="部门：" prop="comp">
          <el-input style="width:300px" v-model="form.comp" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门负责人:" prop="person">
          <div class="myicon" v-for="(item,index) in form.person" :key="index">
            <el-input style="width:300px" v-model="item.name" placeholder="请输入部门负责人名"></el-input>
            <div class="add-fzr" @click="editfzr(index,'new')">
              <el-tooltip class="item" effect="dark" content="添加负责人" placement="top">
                <i class="el-icon-plus"></i>
              </el-tooltip>
            </div>
            <div class="remove-fzr" @click="editfzr(index,'del')">
              <el-tooltip class="item" effect="dark" content="删除本负责人" placement="top">
                <i class="el-icon-minus"></i>
              </el-tooltip>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata" class="btn-submit1">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import {get_departments, create_departments, mod_departments, del_departments} from "../../api/user";

export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      id: '',
      tableData: [],
      currentPage: 1,
      total: 0,
      limit: 10,
      form: {
        id: '',
        name: '',
        comp: '',
        person: [{name:''}]
      },
      pw: '',
      rules: {
        comp: [
          {required: true, message: '请输入部门', trigger: 'change'}
        ],
        // person: [
        //   {required: true, message: '请输入部门负责人名', trigger: 'change'}
        // ],
      },
      actic: 'actic'
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //添加删除负责人
    editfzr(index,type) {
      if(type == 'new'){
      //  新增负责人
        if(this.form.person.length == 5){
          this.$message.warning('注意，最多可添加五名负责人！')
          return
        }
        let item = {
          name:''
        }
        this.form.person.push(item)
      }else{
        //删除负责人
        if(this.form.person.length == 1){
          this.$message.warning('注意，负责人不可全部删除！')
          return
        }
        this.form.person.splice(index,1)
      }
    },
    //跳转至部门详情
    jumpXQ(row) {
      this.$router.push({path: '/state/bumen_xq', query: {id: row.id, name: row.department_name}})
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData()
    },
    getData() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: 10
      }
      get_departments(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          // this.limit = res.limit;
          this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //删除单个
    delColomn(id) {
      this.$confirm('确定删除该部门吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            departments_id: id
          }
          del_departments(params).then(res => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    //修改部门
    comedit(index, row) {
      if (row != 'new') {
        this.title = '修改'
        this.form.id = row.id
        this.form.comp = row.department_name
        // this.form.person = row.person
        var newArr = []
        for (let i = 0; i < row.person.split(',').length; i++) {
          let item = {
            name:row.person.split(',')[i]
          }
          newArr.push(item)
        }
        this.form.person = newArr
        this.dialogVisible = true
      } else {
        this.title = '新增'
        this.form.id = ''
        // this.form.name = ''
        this.form.comp = ''
        this.form.person = [{name:''}]
        this.dialogVisible = true
      }
    },
    uodata() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.comp == '') {
            this.$message.warning('请完善信息后再提交！')
            return
          }
          let person = []
          for (let i = 0; i < this.form.person.length; i++) {
            if(this.form.person[i].name == ''){
              this.$message.warning('注意，负责人名称不得为空！')
              return
            }
            person.push(this.form.person[i].name)
          }
          if(person.length == 0){
            this.$message.warning('请完善负责人信息后再提交！')
            return
          }
          if (this.title == '修改') {
            let params = {
              departments_id: this.form.id,
              departmentname: this.form.comp,
              person: person.join(',')
              // person:this.form.name
            }
            mod_departments(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('修改成功')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            let params = {
              departmentname: this.form.comp,
              person: person.join(',')
              // person:this.form.name
            }
            create_departments(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('新建部门成功，请在部门详情中添加固定成本！')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }


        } else {
          return false;
        }
      });
      //
      //
      // }
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
.content >>> .el-switch__label {
  line-height: 20px;
}

.content >>> .el-switch {
  height: 40px;
  line-height: 40px;
  width: 200px;
}

.content >>> .el-dialog__footer {
  text-align: center;
}

.actic {
  color: red;
}

.content >>> .el-dialog {
  width: 30%;
}

.content >>> .el-dialog__title {
  color: #25396f;
  font-size: 16px;
}

.content >>> .el-dialog__body {
  font-size: 12px;
  color: #25396f;
}

.diago >>> .el-dialog {
  min-width: 430px;
}

.myicon {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 15px;
}

.remove-fzr, .add-fzr {
  margin-left: 10px;
  padding: 0 10px;
  color: #ffffff;
  background-color: #409eff;
  cursor: pointer;
}

.remove-fzr {
  background-color: #f74f47;
  margin-left: 10px;
}
</style>





// WEBPACK FOOTER //
// src/views/share/department.vue